export enum USER_SCREEN_LIST {

}

export enum USER_REQUEST_ID_LIST {
  GET_USER = 'GET_USER',
  ADD_USER = 'ADD_USER',
  DELETE_USER = 'DELETE_USER',
  EDIT_USER = 'EDIT_USER'
}
